class MySelect {
  constructor(select){
    this._select = select;
    this._selectParent = select.parentElement;
    this._styleSelect();
    this._select.querySelectorAll('option').forEach(op => {
      op.addEventListener('click', this._select.blur);
    })
  }
  // Getters and setters
  getSelect = () => {
    return this._select;
  }
  
  // End Getters and Setters
  // _addMDCToInput = () => {
  //   this._input.classList.add('mdc-text-field__input');
  //   this._newParentElement = document.createElement('div');
  //   this._input.insertAdjacentElement('beforebegin', this._newParentElement);
  //   this._newParentElement.classList.add('mdc-text-field', 'mdc-text-field--outlined');
  //   this._newParentElement.append(this._input);
  //   // console.log('mdcparent', this._input.parentElement);
  //   // const label = document.querySelector(`[For="${this._input.id}"]`).innerHTML;
  //   // const notch = this._addNotchInput(label);
  //   // this._input.insertAdjacentElement('afterend', notch);
  // }

  _styleSelect = () => {
    this._selectParent.style.height = '40px';
    this._selectParent.classList.add('select-wrapper');
    this._select.style.height = '100%';
    this._selectParent.parentElement.style.marginTop = '15px';
  }  
}

const infiniteOptionsContainer = document.querySelector('#infiniteoptions-container');
// create a new MutationObserver
const config = { childList: true };
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    // configure the observer to watch for changes to the element's inner HTML
    if (infiniteOptionsContainer != null) {
        const selectList = infiniteOptionsContainer.querySelectorAll('select');
      console.log(selectList);
        if (selectList.length > 0) {
            for(let i = 0; i < selectList.length; i++) {
              const select = selectList[i];
              // console.log(input);
              if (select != null) {
                const mySelect = new MySelect(select);
              }
            }
        }
    }
  });
});
observer.observe(infiniteOptionsContainer, config);

